import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseLabel from "../base/base-label.vue";
import BaseInput from "../base/base-input.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
import { useInputMask } from "@Shared/@Composables/inputs/useInputMaks";
import { useI18n } from "vue-i18n-composable";
import moment from "moment";
import { nextTick } from "process";
export default defineComponent({
  name: "DateField",
  components: {
    BaseLabel,
    BaseInput,
    BaseFieldLayout
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "YYYY-MM-DD"
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      locale
    } = useI18n();
    const {
      value,
      min,
      max,
      disabled,
      readonly
    } = toRefs(props);
    const datepickerOptions = computed(() => ({
      masks: {
        input: "YYYY-MM-DD"
      },
      attributes: [{
        key: "today",
        highlight: {
          fillMode: "light",
          color: "primary"
        },
        dates: new Date()
      }],
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
        timeAdjust: "12:00:00"
      },
      locale: locale.value.replace("-CA", ""),
      popoverVisibility: disabled.value || readonly.value ? "hidden" : "focus"
    }));
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    const {
      buildDateMask
    } = useInputMask();
    const {
      inputMask
    } = buildDateMask();
    const minDate = computed(() => {
      if (!min.value) return null;
      if (min.value === "today") return moment().toDate();
      return moment(min.value, "YYYY-MM-DD").toDate();
    });
    const maxDate = computed(() => {
      if (!max.value) return null;
      if (max.value === "today") return moment().toDate();
      return moment(max.value, "YYYY-MM-DD").toDate();
    });
    const handleIconClick = async ref => {
      nextTick(() => ref.focus());
    };
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      inputMask,
      datepickerOptions,
      minDate,
      maxDate,
      handleIconClick
    };
  }
});